import React from "react";
import PropTypes from "prop-types";
import ResizableContainer from "components/ResizableContainer";
import Ellipsis from "components/Ellipsis";

const ByContentHeader = ({ columnWidths, onResize, headerRef }) => {
  const headerConfig = [
    {
      content: "",
      minWidth: 25,
    },
    {
      content: "Location",
      minWidth: 20,
    },
    {
      content: "Ref",
      minWidth: 20,
    },
    {
      content: "Content",
      minWidth: 350,
    },
    {
      content: "Items",
      minWidth: 650,
    },
  ];

  return (
    <div
      className="by_content__header"
      data-testid="by-content-header"
      ref={headerRef}
    >
      <div className="by_content__header__row">
        {headerConfig.map(({ content, minWidth }, index) => (
          <ResizableContainer
            index={index}
            width={columnWidths[index]}
            minWidth={minWidth}
            disableResizing={index === headerConfig.length - 1}
            onResize={onResize}
          >
            <Ellipsis text={content} />
          </ResizableContainer>
        ))}
      </div>
    </div>
  );
};

ByContentHeader.propTypes = {
  columnWidths: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
  onResize: PropTypes.func.isRequired,
  headerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default ByContentHeader;
